export class SoundConstants {
    static readonly BASE_MUSIC = 'base_music_loop';
    static readonly FREEGAME_MUSIC = 'free_background_loop';
    // static readonly BASE_MUSIC = 'base_music_ambient';
    // static readonly FREEGAME_MUSIC = 'base_music_ambient';
    static readonly INTRO_MUSIC = 'Intro_transition';
    static readonly REELS_SPIN = 'reels_spinning';
    static readonly REEL_STOP = 'reel_stop';
    static readonly SCATTER_TRIGGER = 'Scatter_Trigger';
    static readonly SCATTER_LAND = 'scatter_land';
    static readonly BUTTON_CLICK = 'click';
    static readonly BET_LEVEL = "bet-level";
    static readonly TOTAL_WIN = "total_win";
    static readonly ANTICIPATION_LOOP = "scatter_anticipation_loop";
    static readonly SYMBOL_WIN = "symbol_win";
    static readonly BIG_WIN_LOOP = "win_loop";
    static readonly WIN_TICKUP = "win_tickup";
    static readonly WIN_TICKUP_END = "win_tickup_end";
    static readonly FEATURE_BANNER = "free_Game_Banner";
    static readonly BIG_WIN = "Big_Win_Transition";
    static readonly MEGA_WIN = "Mega_Win_Transition";
    static readonly SUPER_WIN = "Super_Win_Transition";
    static readonly EPIC_WIN = "Epic_Win_Transition";
    static readonly ENDING_TRANSITION = "Ending_transition";
    static readonly BALLONS_TRANSITION = "Ballon_transition";
    static readonly BANNER_ENDING_MUSIC = "Banner_ending";
    static readonly FREESPINS_ADDED = "Free_Spins_Added";
    static readonly SYMBOL_HIGHLIGHTED = "Symbol_highlighted";
    static readonly RIP_REVEAL = "RIP_reveal";
    static readonly RIP_SYMBOL = "RIP_symbol";
    static readonly COIN_FLIP = "symbol_reveal";
    static readonly METER_ACTIVE = "Meter_Active";
    static readonly REAWAKEN = "Reawaken";
    static readonly TOMBSTONE_HIGHLIGHTED = "Tombstone_highlighted";
    static readonly LEFT_TOMBSTONE_APPEAR = "left_tombstone_appears";
    static readonly LEFT_TOMBSTONE_VANISH = "left_tombstone_vanishes";
    static readonly HIGHER_WIN = "higher_win";  
    static readonly REAWAKEN_SYMBOL = "reawaken_symbol";
    static readonly SCATTER_LANDED = "scatter_landed";
    static readonly TRAIL = "trail_sound";
}